import { render, staticRenderFns } from "./bottomRight.vue?vue&type=template&id=0b2d7848&scoped=true"
import script from "./bottomRight.vue?vue&type=script&lang=js"
export * from "./bottomRight.vue?vue&type=script&lang=js"
import style0 from "./bottomRight.vue?vue&type=style&index=0&id=0b2d7848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2d7848",
  null
  
)

export default component.exports